import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AllPostContext } from '../../contextStore/AllPostContext';
import Pagination from '../Pagination/Pagination';
import PostCards from '../PostCards/PostCards';
import './allposts.css';

function AllPosts() {
  const { t } = useTranslation();
  const { allPost } = useContext(AllPostContext);
  const length = allPost.length;
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allPost.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(allPost.length / itemsPerPage);

  const displayPosts = currentItems.map((product, index) => (
    <div className="allPostCard" key={product?.id || index}>
      <PostCards product={product} index={index} />
    </div>
  ));

  if (length === 0) {
    history.push('/');
    return null;
  }

  return (
    <div className="allPostsPage">
      <div className="allPostsContainer">
        <div className="allPostsHeading">
          <h2>{t('infoPages.allPosts.title')}</h2>
          <span className="allPostsCount">{t('infoPages.allPosts.results', { count: allPost.length })}</span>
        </div>
        <div className="allPostsGrid">{displayPosts}</div>
        {totalPages > 1 && (
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </div>
  );
}

export default AllPosts;
